import React from 'react';
import { AiOutlineControl } from 'react-icons/ai';

const FloatingActionButton = ({ onClick }) => {
  return (
    <button 
      className="floating-action-button"
      onClick={onClick}
      title="Nova Requisição de Controle de Exaustão"
    >
      <AiOutlineControl className="controlIcon"/>
      <span className="tooltip-text">Clique para controlar os exaustores</span>
    </button>
  );
};

export default FloatingActionButton;
